
import LanguageSwitch from '@/UI/components/brand/LanguageSwitch.vue';
import {Component, Vue} from 'vue-property-decorator';
import RecoverMainForm from "@/form/recover/recoverMain/recoverMain";
import RecoverCodeForm from "@/form/recover/recoverCode/recoverCode";
import RecoverPasswordForm from "@/form/recover/recoverPassword/recoverPassword";
import RecoverMain from "@/UI/components/forms/recover/RecoverMain.vue";
import RecoverCode from "@/UI/components/forms/recover/RecoverCode.vue";
import RecoverPassword from "@/UI/components/forms/recover/RecoverPassword.vue";
import {RecoverStore} from "@/store/modules/Recover";
import {AuthStore} from "@/store/modules/Auth";
@Component({
  components: {LanguageSwitch,RecoverPassword, RecoverCode, RecoverMain}
})
export default class Recover extends Vue {
  main = new RecoverMainForm();
  code = new RecoverCodeForm();
  password = new RecoverPasswordForm();
  sendPhone = false;
  codeStep = false;
  async submitPhone(): Promise<void> {
    if (await this.main.submit(RecoverStore.checkCode)) {
      this.code.phone = this.main.phone;
      this.sendPhone = true;
      this.codeStep = true;
    }
  }
  async submitCode(): Promise<void> {
    if (await this.code.submit(RecoverStore.sendCode)) {
      this.password.phone = this.main.phone;
      this.codeStep = false;
    }
  }
  async submitPass(): Promise<void> {
    if (await this.password.submit(RecoverStore.recoverDo)) {
      await AuthStore.login({phone: this.password.phone, password: this.password.password});
    }
  }
}
